import { Map, List } from "immutable";
import { ENUM_GET_ACTIONS_SUCCESSFUL } from "UserAuthorized/actionTypes";

const InitialState = {
  actions: List()
};

const enumReducer = (state = Map(InitialState), action) => {
  switch (action.type) {
    case ENUM_GET_ACTIONS_SUCCESSFUL:
      return state.set("actions", List(action.payload));
    default:
      return state;
  }
};

export default enumReducer;
